module.exports = __webpack_public_path__ + "img/1_1-basket-0.379696eb.png";